import * as React from "react";
import { Admin, Resource, ListGuesser } from "react-admin";
import dataProvider from "./dataProvider/dataProvider";
import authProvider from "./authProvider/authProvider";
import RecipesList from './customLists/RecipesList';
import ProductsList from './customLists/ProductsList';
import ConfigsList from './customLists/ConfigsList';
import PackagesList from './customLists/PackagesList';
import RecyclingsList from './customLists/RecyclingsList';
import RecipesEdit from './customEdits/RecipesEdit';
import ProductsEdit from './customEdits/ProductsEdit';
import ConfigsEdit from './customEdits/ConfigsEdit';
import PackagesEdit from './customEdits/PackagesEdit';
import RecyclingsEdit from './customEdits/RecyclingsEdit';
import RecipesCreate from './customCreates/RecipesCreate';
import ProductsCreate from './customCreates/ProductsCreate';
import PackagesCreate from './customCreates/PackagesCreate';
import RecyclingsCreate from './customCreates/RecyclingsCreate';
import ConfigsCreate from './customCreates/ConfigsCreate';

import portugueseMessages from 'ra-language-portuguese';


import polyglotI18nProvider from 'ra-i18n-polyglot';
import customPortugueseMessages from './i18n/pt';


const i18nProvider = polyglotI18nProvider(() => customPortugueseMessages, 'pt');


const App = () => (
  <Admin dataProvider={dataProvider} authProvider={authProvider} i18nProvider={i18nProvider}>
    <Resource name="products" list={ProductsList} edit={ProductsEdit} create={ProductsCreate} options={{ label: 'Produtos' }}/>
    <Resource name="recipes" list={RecipesList} edit={RecipesEdit} create={RecipesCreate} options={{ label: 'Receitas' }}/>
    <Resource name="configs" list={ConfigsList} edit={ConfigsEdit} create={ConfigsCreate} options={{ label: 'Configurações' }}/>
    <Resource name="packages" list={PackagesList} edit={PackagesEdit} create={PackagesCreate} options={{ label: 'Embalagens' }}/>
    <Resource name="recyclings" list={RecyclingsList} edit={RecyclingsEdit} create={RecyclingsCreate} options={{ label: 'Componentes' }}/>
  </Admin>
);

export default App;
